import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';
import { BusTimesPage } from '@/features/bus-times/BusTimesPage';
import { NotFoundPage } from '@/components/NotFoundPage';
import type { AppEntry } from '@/app/routes-types';

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    title?: string;
    page?: string;
    standalone?: boolean;
    isPublic?: boolean;
    entersFrom?: string;
  }
}

export const entry: AppEntry = { default: '/', byRole: {} };

const rootRoute = createRootRoute({ notFoundComponent: NotFoundPage });
const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: BusTimesPage,
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  staticData: {
    title: 'Bus times',
    page: SURFACES['bus-times'],
    standalone: false,
    isPublic: true,
  },
});

export const router = createRouter({ routeTree: rootRoute.addChildren([busTimesRoute]) });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
